export default __webpack_public_path__ + "static/media/landingBg3.093ed826.png";